import { ActionList, ActionMenu } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { loaiThuocApi } from '../../api/loaiThuocApi';
import { ts_hocsinh_lichsu_yte_loaithuoc } from '../../models/response/category/ts_hocsinh_lichsu_yte_loaithuoc';
import { NotifyHelper } from '../../helpers/toast';

type ComboboxLoaiThuocProps = {
    isReadonly?: boolean;
    value?: number;
    onValueChanged: (value: number, data?: ts_hocsinh_lichsu_yte_loaithuoc) => void;
    className?: string;
    isShowClearButton?: boolean;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
};

export const ComboboxLoaiThuoc = (props: ComboboxLoaiThuocProps) => {
    const [loaiThuocList, setLoaiThuocList] = useState<ts_hocsinh_lichsu_yte_loaithuoc[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { translate } = useCommonContext();
    const { dm_coso_id } = useCommonSelectedHook();

    const loadLoaiThuoc = async () => {
        try {
            setIsLoading(true);
            const response = await loaiThuocApi.selectAll();
            if (response.is_success) {
                // Lọc theo dm_coso_id
                const filteredData = (response.data || []).filter((item: ts_hocsinh_lichsu_yte_loaithuoc) => item.dm_coso_id === dm_coso_id);
                setLoaiThuocList(filteredData);
            } else {
                NotifyHelper.Error("Có lỗi khi tải danh sách loại thuốc");
            }
        } catch (error: any) {
            NotifyHelper.Error(error.message || "Có lỗi khi tải danh sách loại thuốc");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadLoaiThuoc();
    }, [dm_coso_id]);

    const dataSource = useMemo(() => {
        return loaiThuocList.map(x => ({
            value: x.id,
            text: x.ten_thuoc + (x.ten_thuoc_en ? ` (${x.ten_thuoc_en})` : ""),
            data: x
        }));
    }, [loaiThuocList]);

    const selectedData = useMemo(() => {
        if (props.value && dataSource) {
            return dataSource.find(x => x.value === props.value);
        }
        return undefined;
    }, [dataSource, props.value]);

    return (
        <div style={{ width: '100%' }}>
            <ActionMenu>
                <ActionMenu.Button
                    aria-label="Chọn loại thuốc"
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                    disabled={props.isReadonly || isLoading}
                >
                    {selectedData ? selectedData.text : translate("Chọn loại thuốc")}
                </ActionMenu.Button>
                <ActionMenu.Overlay width="small">
                    <ActionList selectionVariant="single">
                        {props.isShowClearButton &&
                            <ActionList.Item
                                key={0}
                                selected={!props.value || props.value === 0}
                                onSelect={() => {
                                    props.onValueChanged(0)
                                }}
                            >
                                {"Chọn loại thuốc"}
                            </ActionList.Item>
                        }
                        {dataSource && dataSource.map((item) => {
                            return (
                                <ActionList.Item
                                    key={item.value}
                                    selected={props.value !== undefined && item.value === props.value}
                                    onSelect={() => {
                                        props.onValueChanged(item.value, item.data)
                                    }}
                                >
                                    {item.text}
                                </ActionList.Item>
                            );
                        })}
                    </ActionList>
                </ActionMenu.Overlay>
            </ActionMenu>
        </div>
    );
};

export default ComboboxLoaiThuoc;
